<div
    class="absolute bg-black/50 opacity-0 hover:opacity-100 top-0 left-0 w-full h-full flex flex-col justify-center items-center cursor-pointer transition-opacity z-20"
    [class.isHighlighted]="isHighlighted"
    [ngClass]="{
        'opacity-1': isHighlighted,
        'bg-none': isHighlighted
    }"
    *ngIf="editMode"
    (click)="triggerEditComponent()">
    <div *ngIf="isHighlighted" class="absolute top-2 left-2 w-[100px] h-[20px] p-2 text-sm text-center text-white">
        {{ component ? componentMap[component.type]?.label : "Component" }}
    </div>
</div>
